<template>
  <div>
    <b-form-group label="Nome:">
      <b-form-input
        v-model="moeda.nome"
        placeholder="Nome"
        :state="validateState('nome')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Sigla:">
      <b-form-input
        v-model="moeda.sigla"
        placeholder="simbolo"
        :state="validateState('sigla')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    moeda: {
      nome: {
        required,
        minLength: minLength(3),
      },
      sigla: {
        required,
      },
    },
  },
  computed: {
    ...mapState("moedas", ["moeda"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.moeda[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.moeda.$touch();
      return !this.$v.moeda.$anyError;
    },
  },
  created() {},
};
</script>
